import { RouterParents, RouterPaths } from "./routerPaths";
import { createRoutes } from "@pasport/react-common";

const routingPath = createRoutes(RouterParents, RouterPaths);
export const getAbsoluteRoutePath = routingPath.getAbsoluteRoutePath;
